import { useState } from "react";
import { Button, Col, Collapse, Container, Row } from "react-bootstrap";
import { useMediaQuery } from 'react-responsive';
import { Link, useLocation } from "react-router-dom";

import logo from "../img/sh-logo_site.png";

import { CombinedNav, SiteNav, UserNav } from "./UserNav";
import ThemeToggle from "./ThemeToggle";

import useUserStore from "../stores/User";

type NavbarProps = {
  logoShow?: boolean
};

const Navbar: React.FC<NavbarProps> = ({ logoShow = true }) => {
  const [open, setOpen] = useState(false);
  const isExtraLarge = useMediaQuery({ query: '(min-width: 1200px)' });

  const location = useLocation();
  const suppressNavbar = ['/','/databaselogin','/register', '/resetpassword', '/newpassword'];

  const userData = useUserStore((state) => state.data);
  const isLoading = useUserStore((state) => state.loading);

  return (
    <Container fluid className="px-3 px-sm-5 my-3">
      <Row xs={12} className="d-flex align-items-center">
        {logoShow && (<Col xs="auto">
          <Link to="/" title="Script Hive">
            <img src={logo} alt="Script Hive logo" width={90} />
          </Link>     
        </Col>)}
        {!suppressNavbar.includes(location.pathname.toLowerCase()) && [
            <Col key="nav-col">
              {isExtraLarge && (<SiteNav />)}
            </Col>,
            <Col key="user-col" xs="auto" className="d-flex justify-content-end">
              {isExtraLarge ? (
                <UserNav />
              ) : (
                <>
                  {userData && !isLoading && (
                    <span className="me-2 pt-2">
                      <ThemeToggle />
                    </span>
                  )}
                  <Button
                    onClick={() => setOpen(!open)}
                    className="btn btn-primary navbutton"
                  >
                    Menu <i className="bi bi-list"></i>
                  </Button>
                </>
              )}
            </Col>
        ]}
      </Row>
      {!isExtraLarge && !suppressNavbar.includes(location.pathname.toLowerCase()) && (
        <Row className="mt-2">
          <Col>
            <Collapse in={open}>
              <div>
                <CombinedNav setOpen={setOpen} />
              </div>
            </Collapse>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default Navbar;